import styled from 'styled-components';

export const LoaderContainer = styled.div`
  padding: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default LoaderContainer;
